export function useOnClick(props) {
  return function onClick() {
    if (props.scrollContainerRef?.current) {
      props.scrollContainerRef.current.scrollTo({
        left: props.scrollContainerRef.current.scrollWidth,
        behavior: 'smooth',
      })
    }
  }
}
